import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { queueReducer } from './queue.reducer';
import { STATE_FEATURE_QUEUE, getInitialQueueState } from './queue.state';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_FEATURE_QUEUE, queueReducer, {
      initialState: getInitialQueueState,
    }),
  ],
})
export class QueueModule {}
